export default "__VITE_ASSET__e11NDMTH__"